import { returnToNativeShell } from './../../core/nativeShell.js';

angular.module('userSettingsMod')

.controller('userAccountCtrl', ['$location', '$scope', 'cnfg', '$templateCache', 'storage', '$timeout', 'GhDialog', 'authService', 'authApi', '$window', 'localizationService', function($location, $scope, cnfg, $templateCache, storage, $timeout, GhDialog, authService, authApi, $window, localizationService) {

	var change_avatar = false;

	const dictionary = localizationService.getDictionary('account_settings');
	const translate = (word) => localizationService.translate(word, dictionary);

	$scope.tabs = [
		{ name: translate('General') },
		{ name: translate('Password') },
		{ name: translate('Account') }
	];
	$scope.currentTab = 0;
	$scope.mobileTabDetailOpen = false;
	$scope.switchTab = function(index) {
		$scope.currentTab = index;
		$scope.mobileTabDetailOpen = true;
		$scope.nav.title = $scope.tabs[index].name;
		$scope.nav.onBack = function(){
			$scope.mobileTabDetailOpen = false;
			$scope.nav.onBack = null;
			$scope.nav.title = null;
		};
	};

	$scope.storage_user = angular.copy(storage.getMainStorage().user);
	$scope.account_form = {};

	$scope.avatar_field_model = {
			image_size: 512,
			avatar_size: 180,
			uploadEvents: true
	};

	if($scope.storage_user){
			$scope.account_form = {
					first_name: $scope.storage_user.fullname.split(' ')[0] || '',
					last_name: $scope.storage_user.fullname.split(' ')[1] || '',
					language: $scope.storage_user.language || 'en'
			};
	}

	$scope.$watch('storage_user.avatar_512', function(newVal, oldVal){
		if(newVal !== oldVal){
			change_avatar = true;
		}
	});

	$scope.send = async function(accountForm) {
		var data = angular.copy($scope.account_form);
		if (accountForm.$valid) {

			var dataToSend = {
				user_id: $scope.storage_user.user_id,
				fullname: data.first_name + ' ' + data.last_name,
				username: $scope.storage_user.username,
				language: data.language
			};

			if(change_avatar){
				dataToSend.avatar = $scope.storage_user.avatar_512.replace(/^data:image\/(gif|jpg|jpeg|tiff|png);base64,/, "");
			}

			try {

				let user = await gudhub.updateUser(dataToSend);

				localStorage.setItem('user', JSON.stringify({
					fullname: user.fullname,
					avatar: user.avatar_512
				}));

				$scope.errMsg = translate('Account have been updated');
				$scope.$digest();

			} catch(error) {

				$scope.errMsg = error.data + ' Please, try again...';

			} finally {

				$timeout(function() {
					$scope.errMsg = "";
				}, 1500);
			}
		}
	};

	$scope.cancel = function(){
		$location.path('/apps');
	};

	$scope.deleteAccount = function() {
		GhDialog.show({
			position: 'center',
			mobile_position: 'bottom_mobile',
			toolbar: false,
			template: {
				toolbar: '',
				resizable: false,
				content: `
					<div style="padding: 20px; position: relative; min-width: 360px; text-align: center;">
						<span gh-icon="cross 0D99FF 20px" style="position: absolute; top: 4px; right: 4px; cursor: pointer;" ng-click="cancel()" ng-if="!deleting"></span>
						<div ng-if="!deleting">
							<h3 style="font-size: 18px; font-weight: 500; margin-bottom: 12px; color: #333;">{{translate('Delete Account')}}</h3>
							<p style="font-size: 14px; color: #666; margin-bottom: 20px;">{{translate('This action cannot be undone')}}. {{translate('Are you sure you want to delete your account')}}?</p>
							<p style="font-size: 13px; color: #666; margin-bottom: 8px; text-align: left;">{{translate('Type your email to confirm')}}</p>
							<input type="text" id="deleteAccountEmailInput" class="disable-gudhub-styles" ng-model="typedEmail" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" style="width: 100%; box-sizing: border-box; margin-bottom: 20px; padding: 10px 16px; font-size: 13px; color: #333; border: 1px solid #e0e0e0; border-radius: 8px; background-color: #fafbfc; outline: none;" />
							<div layout="row" layout-align="center center" class="err" style="color: #e02020; min-height: 18px; margin-bottom: 8px;">{{errMsg}}</div>
							<div style="display: flex; gap: 10px; justify-content: center;">
								<button class="btn btn-blue-reverse" ng-click="cancel()">{{translate('Cancel')}}</button>
								<button class="btn btn-red" ng-click="confirm()">{{translate('Delete')}}</button>
							</div>
						</div>
						<div ng-if="deleting" style="min-width: 360px; min-height: 260px; box-sizing: border-box; display: flex; align-items: center; justify-content: center;">
							<gh-loader color="blue"></gh-loader>
						</div>
					</div>
				`
			},
			locals: { userName: $scope.storage_user.username },
			controller: ['$scope', 'userName', 'localizationService', 'deleteUserAccount', function($scope, userName, localizationService, deleteUserAccount) {
				const dictionary = localizationService.getDictionary('account_settings');
				$scope.translate = (word) => localizationService.translate(word, dictionary);
				$scope.typedEmail = '';
				$scope.deleting = false;
				$scope.errMsg = '';

				$scope.confirm = async function() {
					// Chrome autofill can paint a value into the input without firing the
					// 'input' event ng-model listens for, leaving $scope.typedEmail stale/empty
					// even though the field visibly shows text - fall back to the raw DOM value.
					var inputEl = document.getElementById('deleteAccountEmailInput');
					var typedEmail = $scope.typedEmail || (inputEl ? inputEl.value : '');

					if ((typedEmail || '').trim().toLowerCase() !== (userName || '').trim().toLowerCase()) {
						$scope.errMsg = $scope.translate('Email does not match');
						return;
					}

					$scope.deleting = true;
					$scope.errMsg = '';

					try {
						await deleteUserAccount.deleteUser(userName);

						const accessToken = await authService.getToken();
						await authApi.logout(accessToken);

						$window.localStorage.clear();
						storage.unsetUser();
						storage.unsetApps();
						gudhub.appProcessor.clearAppProcessor();

						if (returnToNativeShell()) return;

						window.location.replace(cnfg.file_server_url + '/account-deleted');
					} catch (error) {
						$scope.errMsg = (error.data || 'Failed to delete account') + '. Please, try again...';
						$scope.deleting = false;
						$scope.$applyAsync();
					}
				};
			}]
		});
	};

}]);
